import { FCX } from "@datassential/platform-ui-lib";
import { Slice, SlicesEnum } from "@models/Byo";
import Tabs from "@components/Tabs/Tabs";
import React from "react";
import { useByoDataContext } from "@pages/Byo/ByoContext";

const SlicesTabs: FCX<{
    slices: Slice[];
}> = ({
    slices,
}) => {
    const { activeSliceId, setActiveSliceId } = useByoDataContext();
    return (
        <Tabs
            data={slices.map(i => ({
                id: i.id,
                name: i.name.toLowerCase(),
            }))}
            activeItemId={activeSliceId}
            handleClick={(id) => setActiveSliceId(id as SlicesEnum)}
            title={'show by:'}
        />
    );
};

export default SlicesTabs;